import {z} from 'zod';

import {PaymentTypeSchema} from '@dms/api/shared';

export const TransferDeliveryNoteFormSchema = z.object({
  sourceBranchId: z.string(),
  branchId: z.string(),
  authorizationProfileId: z.string(),
  warehouseId: z.string(),
  deliveryNoteNumber: z.string().nullish(),
  issuedAt: z.date().nullish(),
  paymentType: PaymentTypeSchema,
  note: z.string().nullish(),
});

export type TransferDeliveryNoteForm = z.infer<typeof TransferDeliveryNoteFormSchema>;
